import * as React from 'react';

export default function NoResults() {
  return (
    <div style={{ padding: '16px 20px 12px' }} data-test-id="no-results">
      No results found
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/javascripts/components/CreateEntryButton/Menu/NoResults.es6.js